exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "mat-chip {\r\n    max-width: 200px;\r\n}\r\n\r\n.drag-block {\r\n    text-align: center;\r\n    cursor: move;\r\n    position: absolute;\r\n    z-index: 1000;\r\n}\r\n\r\n.drag {\r\n    z-index: 1001;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/homePC/angular-comp/yarukami/src/app/dashboad/dashboad.component.css
// module id = ../../../../../src/app/dashboad/dashboad.component.css
// module chunks = main